import {getViewTournament} from '../api/getViewTournament';
import {setGetViewTournamentAction} from '../action';

const setGetViewTournament = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getViewTournament(params);
  
            if (data.status === 'success') {
                dispatch(setGetViewTournamentAction({
                    start: data.data.date_from ? data.data.date_from : NaN,
                    end: data.data.date_to ? data.data.date_to : NaN,
                    label_name: data.data.name ? data.data.name : '',
                    description: data.data.description ? data.data.description : '',
                    fund: data.data.fund ? data.data.fund : '0',
                    count_winners: data.data.count_winners ? data.data.count_winners : '1',
                    min_bet: data.data.min_bet ? data.data.min_bet : "0",
                    count_spin: data.data.count_spin ? data.data.count_spin : "0",
                    winners: data.data.top_places ? data.data.top_places : [0],
                    status: data.data.status,
                    gameIds: data.data.game_ids.join('\n'),
                    currency: data.data.currency
                }))
            }
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetViewTournament
}